import { StyleRules } from '@material-ui/core/styles';
import { SnackbarContentClassKey } from '@material-ui/core/SnackbarContent';

import { core as theme } from '../styles/core';

export const MuiSnackbarContent: Partial<StyleRules<
  SnackbarContentClassKey
>> = {
  root: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.grey[700],
    padding: 0,
    [theme.breakpoints.up('sm')]: {
      minWidth: 'initial',
    },
  },
  message: {
    padding: 0,
    width: '100%',
  },
};
